import 'isomorphic-fetch';
import stringify from 'qs/lib/stringify';
import { getOptions } from './options.js';
import { RECHARGE_CDN_URL, RECHARGE_API_URL, SHOPIFY_APP_PROXY_URL } from '../constants/api.js';
import { RechargeRequestError } from './error.js';
function stringifyQuery(str) {
  return stringify(str, {
    encode: false,
    indices: false,
    arrayFormat: "comma"
  });
}
async function cdnRequest(method, url, requestOptions = {}) {
  const opts = getOptions();
  return request(method, `${RECHARGE_CDN_URL(opts.environment)}/store/${opts.storeIdentifier}${url}`, requestOptions);
}
async function rechargeApiRequest(method, url, {
  id,
  query,
  data,
  headers
} = {}, session) {
  const {
    environment,
    environmentUri,
    storeIdentifier,
    loginRetryFn
  } = getOptions();
  const token = session.apiToken;
  const rechargeBaseUrl = RECHARGE_API_URL(environment, environmentUri);
  const reqHeaders = {
    "X-Recharge-Access-Token": token,
    "X-Recharge-Version": "2021-11",
    ...(headers ? headers : {})
  };
  const localQuery = {
    shop_url: storeIdentifier,
    ...query
  };
  try {
    return await request(method, `${rechargeBaseUrl}${url}`, {
      id,
      query: localQuery,
      data,
      headers: reqHeaders
    });
  } catch (error) {
    if (loginRetryFn && error instanceof RechargeRequestError && error.status === 401) {
      return loginRetryFn().then(session2 => {
        if (session2) {
          return request(method, `${rechargeBaseUrl}${url}`, {
            id,
            query: localQuery,
            data,
            headers: {
              ...reqHeaders,
              "X-Recharge-Access-Token": session2.apiToken
            }
          });
        }
        throw error;
      });
    }
    throw error;
  }
}
async function shopifyAppProxyRequest(method, url, requestOptions = {}) {
  return request(method, `${SHOPIFY_APP_PROXY_URL}${url}`, requestOptions);
}
async function request(method, url, {
  id,
  query,
  data,
  headers
} = {}) {
  let reqUrl = url.trim();
  if (id) {
    reqUrl = [reqUrl, `${id}`.trim()].join("/");
  }
  if (query) {
    let exQuery;
    [reqUrl, exQuery] = reqUrl.split("?");
    const fullQuery = [exQuery, stringifyQuery(query)].join("&").replace(/^&/, "");
    reqUrl = `${reqUrl}${fullQuery ? `?${fullQuery}` : ""}`;
  }
  let reqBody;
  if (data && method !== "get") {
    reqBody = JSON.stringify(data);
  }
  const reqHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Recharge-App": "storefront-client",
    ...(headers ? headers : {})
  };
  const response = await fetch(reqUrl, {
    method,
    headers: reqHeaders,
    body: reqBody
  });
  let result;
  try {
    result = await response.json();
  } catch (e) {}
  if (!response.ok) {
    if (result && result.error) {
      throw new RechargeRequestError(result.error, response.status);
    } else if (result && result.errors) {
      throw new RechargeRequestError(JSON.stringify(result.errors), response.status);
    } else {
      throw new RechargeRequestError("A connection error occurred while making the request");
    }
  }
  return result;
}
export { cdnRequest, rechargeApiRequest, request, shopifyAppProxyRequest };